<template lang="pug">
.sms-preview
  preview(backgroundColor="neutral100")
    preview-item.mt-0(:title="title")
      preview-iphone.mt-4(color="#EFEFEF")
        v-row
          v-col(cols="2")
            v-icon(color="#007AFF" size="26") mdi-chevron-left 
          v-col(cols="8")
            v-avatar.neutral100--text(color="#EF89A1" size="32") YZ
            div.text-2xs.neutral700--text.mt-1 Clinic name
              v-icon(color="neutral500" size="18") mdi-chevron-right 
          v-col(cols="2")
        
        div.mx-n4.mt-4.text-start
          v-divider
          div.neutral100.pa-4(style="min-height: 200px;")
            template(v-for="(chunk, idx) in messageChunks")
              div.d-flex.pr-6
                v-card.chat-bubble(v-if="chunk" flat color="#E9E9EB" :class="!idx || 'mt-4'") {{ chunk }}
</template>

<script>
import Preview from '@/components/review/preview/Preview.vue'
import PreviewItem from '@/components/review/preview/PreviewItem.vue'
import PreviewIphone from '@/components/review/preview/PreviewIphone.vue'
import {mapGetters} from "vuex";

export default {
  components: { Preview, PreviewItem, PreviewIphone, },
  props: ['title', 'sender', 'content'],
  computed: {
    ...mapGetters({
      offer: 'marketing/getOffer',
      setting: 'marketing/getMarketingSettings'
    }),
    messageChunks() {
      let message = `${this.sender || ''}${this.content || ''}`
      message = message.replace(/{{ offer_code }}/g, this.replaceCodeValue)
      message = message.replace(/{{ expiry_date }}/g, this.replaceExpiryDataValue)
      message = message.replace(/{{ brand_name }}/g, this.replaceBrandNameValue)
      const chunkSize = 155
      const chunks = []
      for (let i = 0; i < message.length; i += chunkSize) {
        chunks.push(message.slice(i, i + chunkSize))
      }

      return chunks;
    },
    hasSmsHeader () {
      return this.setting && this.setting.sms_header
    },
    replaceCodeValue () {
      if (this.offer.redeem_method === 'unique_code') return 'CODE'
      if (this.offer.redeem_method === 'general_code') return this.offer.coupon_code ?? ''
      return ''
    },
    replaceExpiryDataValue () {
      if (this.offer.end_at) return this.$options.filters.displayDate(this.offer.end_at)
      if (this.offer.end_after_value && this.offer.end_after_unit) return 'DD/MM/YYYY'
      return ''
    },
    replaceBrandNameValue () {
      if (this.hasSmsHeader) return this.setting.sms_header
      return ''
    }
  }
};
</script>

<style scoped lang="scss">
.chat-bubble {
  padding: 4px 8px 4px 8px;
  border-radius: 14px;
  &:before {
    content: "";
    position: absolute;
    bottom: 10%;
    left: -10px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 15px 15px 0 0;
    border-color: transparent #E9E9EB transparent transparent;
  }
}
</style>
